import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMenuItems } from '../../helpers/api_helper';

const useObtenerMenuItems = (refresh = 0) => {
    const [menuItems, setMenuItems] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchMenuItems = async () => {
            if (!tenantId || !empresa) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getMenuItems({
                    tenantId, empresa
                });
                setMenuItems(response);
            } catch (err) {
                const errorMessage = `Failed to fetch menu items: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setMenuItems(null);
            } finally {
                setLoading(false);
            }
        };

        fetchMenuItems();
    }, [tenantId, empresa, refresh]);

    return { menuItems, loading, error };
};

export default useObtenerMenuItems;